export const CREATE_WORK_ORDER_SUCCESS = 'CREATE_WORK_ORDER_SUCCESS';
export const GET_WORK_ORDER_DETAIL_SUCCESS = 'GET_WORK_ORDER_DETAIL_SUCCESS';
export const SEARCH_WORK_ORDER_LIST_SUCCESS = 'SEARCH_WORK_ORDER_LIST_SUCCESS';
export const SEARCH_WORK_ORDER_LIST_FAIL = 'SEARCH_WORK_ORDER_LIST_FAIL';
export const CREATE_WORK_ORDER_ASYNC = 'CREATE_WORK_ORDER_ASYNC';
export const GET_WORK_ORDER_DETAIL_ASYNC = 'GET_WORK_ORDER_DETAIL_ASYNC';
export const SEARCH_WORK_ORDER_LIST_ASYNC = 'SEARCH_WORK_ORDER_LIST_ASYNC';
export const GET_GLOBAL_WORK_ORDER_DETAIL_ASYNC =
  'GET_GLOBAL_WORK_ORDER_DETAIL_ASYNC';
export const CREATE_CUSTOM_ORDER_ASYNC = 'CREATE_CUSTOM_ORDER_ASYNC'
export const GET_DEFAULT_CONFIG_FOR_DROPDOWN = 'GET_DEFAULT_CONFIG_FOR_DROPDOWN'
export const SUBMIT_DEFAULT_CONFIG = 'SUBMIT_DEFAULT_CONFIG'
export const GET_DEFAULT_CONFIG_FOR_DROPDOWN_SUCCESS = 'GET_DEFAULT_CONFIG_FOR_DROPDOWN_SUCCESS'
export const SELECT_DEFAULT_CONFIG_TRADE_ASYNC = 'SELECT_DEFAULT_CONFIG_TRADE_ASYNC'
export const SELECT_TRADE_SUCCESS = 'SELECT_TRADE_SUCCESS'


// WEBPACK FOOTER //
// ./src/DefaultConfig/constants.js